import { useQuery } from '@tanstack/react-query';
import { PlainDateString } from '@sdk/types';
import useSlingApi from '@sdk/api/useSlingApi';

import { getUserIdByDateQueryKey } from '@web/common/utils/getQueryKey';

const STALE_TIME = 1000 * 60 * 60; // 1h

export const useGetUserIdsByWorkDay = (date: PlainDateString) => {
  const { schedule } = useSlingApi();
  const queryKey = getUserIdByDateQueryKey(date);

  const result = useQuery({
    queryKey,
    queryFn: async () => {
      const { data } = await schedule.getWorkingByDate(date);

      return data.map((u) => u.id);
    },
    staleTime: STALE_TIME,
  });

  return result;
};
